import React, { useState } from "react";
import "./Navbar.css";
import logo from "./pictures/logo.jpg";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <img src={logo} alt="Her Safe Home Logo" className="navbar-logo" />
        </Link>
        <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
          &#9776;
        </button>
      </div>
      <ul className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
        <li className={isActive("/route") ? "active" : ""}>
          <Link to="/route">Night Walk Planner</Link>
        </li>
        <li className={isActive("/map") ? "active" : ""}>
          <Link to="/map">SafeRent Map</Link>
        </li>
        <li className={isActive("/model") ? "active" : ""}>
          <Link to="/model">SafeHouse 3D Guide</Link>
        </li>
        <li className={isActive("/quiz") ? "active" : ""}>
          <Link to="/quiz">Home Safety Assessment</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
